require('./modifyChoreStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ commons
const { getLanguage, FormattedText, formatText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const { CHORE_MAX_AMOUNT, CHORE_MIN_AMOUNT, REPETITION_MAX_LIMIT } = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

//@ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');

// @ components
const InputCharsLeft = require('components/inputCharsLeft/inputCharsLeft');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { AmountInput } = require('commonsComponents/amountInput');

class ModifyChoreStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleConceptChange = this.handleConceptChange.bind(this);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
    }

    componentWillMount(){
        // build repetition options list
        const repetitionInitialList = [{
            value: formatText('modifyChoreStep-noRepetitions'),
            label: formatText('modifyChoreStep-noRepetitions')
        }];

        const repetitionOtherOptions = new Array(REPETITION_MAX_LIMIT)
        .join().split(',')
        .map(function(item, index){
            let _index = index + 2;
            return ({
                value: _index,
                label: _index
            });
        });
        let repetitionOptionList = [...repetitionInitialList, ...repetitionOtherOptions];
        this.props.setRepetitionOptionsList(repetitionOptionList);
    }

    getChoresTypes(choreList){
        const choreTypes = choreList.size && choreList.map((chore) => {
            const choreName = formatText(`openYoungCardChores-task${chore.get('choreId')}`);
            return {
                value: chore.get('choreId'),
                label: choreName
            }
        }).toArray();
        return choreTypes;
    }

    getRepetitionTypes(repetitionOptionList){
         const repetitionTypes = repetitionOptionList.size && repetitionOptionList.map((repetitionType) => {
            return {
                value: repetitionType.get('value'),
                label: repetitionType.get('label')
            }
        }).toArray();
        return repetitionTypes;
    }

    handleConceptChange(event){
        const concept = event.target.value;
        this.props.conceptChanged(concept);
    }

    onHandleDateChange(date){
        this.props.validityDateChanged(date);
    }

    render() {
        const {
            handleAmountChange,
            immCard,
            immChoreDetails,
            immOpenYoungCardModifyChore,
            immStep
        } = this.props;
        const choreList = immOpenYoungCardModifyChore.get('choreList');
        const choresTypes = this.getChoresTypes(choreList);
        const repetitionOptionList = immStep.get('repetitionOptionList');
        const repetitionTypes = this.getRepetitionTypes(repetitionOptionList);

        const amount = immStep.get('amount');
        const selectedEndDate = immStep.get('selectedEndDate');
        const concept = immStep.get('concept') || '';
        const selectedRepetitionType = immChoreDetails.get('repeatTask') || formatText('modifyChoreStep-noRepetitions');
        const selectedChoreType = immChoreDetails.getIn(['chore', 'choreId']);

        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const amountGreaterThanMaximunLimit = immStep.get('amountIsDirty') && amount > CHORE_MAX_AMOUNT;
        const maxLimit = [
            getFormattedString({ amount: CHORE_MAX_AMOUNT, currency })
        ];
        const minLimit = [
            getFormattedString({ amount: CHORE_MIN_AMOUNT, currency })
        ];
        let amountValueErrorMessage;
        const amountValueErrorMinimumLimitCondition = immStep.get('amountIsDirty') && immStep.get('amount') === 0;
        const amountValueErrorMaximunLimitCondition = immStep.get('amountIsDirty') && immStep.get('amount') > CHORE_MAX_AMOUNT;

        if(amountValueErrorMinimumLimitCondition){
            amountValueErrorMessage = formatText('modifyChoreStep1-amountMinimumLimitError', [minLimit]);
        } else if (amountValueErrorMaximunLimitCondition){
            amountValueErrorMessage = formatText('modifyChoreStep1-amountMaximumLimitError', [maxLimit]);
        }

        const pastDateValidationMessage = formatText('modifyChoreStep1-pastDateValidationMessage');
        const pastDateValidationCondition = selectedEndDate && moment(selectedEndDate.format('YYYY-MM-DD')).isBefore(moment().format('YYYY-MM-DD')) && immStep.get('endDateIsDirty');

        return (
            <article className="modify-chore-step-one">
                <header className="modify-chore-step-one__header">
                    <FormattedText value="modifyChoreStep1-title" className="modify-chore-step-one__title" />
                </header>
                <section className="modify-chore-step-one__content">
                    <form>
                        <fieldset className="modify-chore-step-one__chore-select">
                            <OKSelect
                                className="modify-chore-step-one__chore-select-dropdown"
                                label={formatText('modifyChoreStep-chore')}
                                name="modify-chore-step-one-chore"
                                options={choresTypes}
                                searchable={false}
                                value={selectedChoreType}
                                disabled={true}
                            />
                        </fieldset>
                        <fieldset className="modify-chore-step-one__amount">
                            <label>
                                <AmountInput
                                    amount={amount}
                                    callback={handleAmountChange}
                                    disablePaste
                                    error={amountGreaterThanMaximunLimit || amountValueErrorMinimumLimitCondition}
                                    errorMsg={amountValueErrorMessage}
                                    hideFocusZero
                                    id="inp_ModifyChoreStep1_Amount"
                                    label={formatText('modifyChoreStep-amount')}
                                    language={getLanguage()}
                                    min={0}
                                    showBlurZero
                                />
                            </label>
                            <span className="modify-chore-step-one__currency">
                                {currency}
                            </span>
                            <p className="modify-chore-step-one__max-limit">
                                <FormattedText value="modifyChoreStep1-maxAmountLimit" injectedStrings={[maxLimit]} />
                            </p>
                        </fieldset>
                        <fieldset className="modify-chore-step-one__datepicker">
                            <DatePickerCustom
                                callback={this.onHandleDateChange}
                                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                                label={formatText('modifyChoreStep-selectedEndDate')}
                                locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                                minDate={immStep.get('minDate')}
                                placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                                selectedDate={selectedEndDate}
                                errorState={pastDateValidationCondition}
                                errorMessage={pastDateValidationMessage}
                            />
                        </fieldset>
                        <fieldset className="modify-chore-step-one__repetitions-select">
                            <OKSelect
                                className="modify-chore-step-one__repetitions-select-dropdown"
                                label={formatText('modifyChoreStep-repetitions')}
                                name="modify-chore-step-one-repetitions"
                                options={repetitionTypes}
                                searchable={false}
                                value={selectedRepetitionType}
                                disabled={true}
                            />
                        </fieldset>
                        <div className="modify-chore-step-one__concept">
                            <InputCharsLeft
                                callback={this.props.conceptChanged}
                                initialValue={concept}
                                label={formatText('modifyChoreStep-concept')}
                                maxLength="80"
                            />
                            <div className="modify-chore-step-one__warning">
                                <OKMessage type="important">
                                    <FormattedText value="modifyChoreStep1-warning"/>
                                </OKMessage>
                            </div>
                        </div>

                    </form>
                </section>
            </article>
        )
    }
}

ModifyChoreStep1.propTypes = {
    conceptChanged: PropTypes.func.isRequired,
    choreAssignmentId: PropTypes.number.isRequired,
    getChoreDetail: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immOpenYoungCardModifyChore: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    immChoreDetails: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setChoreType: PropTypes.func.isRequired,
    setRepetitionOptionsList: PropTypes.func.isRequired,
    setRepetitionType: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired
};

module.exports = ModifyChoreStep1;
